import React from 'react';
import { Stack, TextField } from '@mui/material';

import type { DocumentMetadataValues } from 'components/Documents/Scanner/types';

interface DocumentMetadataFormProps {
  values: DocumentMetadataValues;
  onChange: (values: DocumentMetadataValues) => void;
  disabled?: boolean;
}

const DocumentMetadataForm: React.FC<DocumentMetadataFormProps> = ({
  values,
  onChange,
  disabled = false,
}) => (
  <Stack spacing={2}>
    <TextField
      label='Document Name'
      required
      fullWidth
      value={values.documentName}
      disabled={disabled}
      onChange={(event) =>
        onChange({ ...values, documentName: event.target.value })
      }
    />
    <TextField
      label='Description (optional)'
      fullWidth
      multiline
      value={values.documentDescription}
      disabled={disabled}
      onChange={(event) =>
        onChange({ ...values, documentDescription: event.target.value })
      }
    />
  </Stack>
);

export default DocumentMetadataForm;
